import m10 from "./_10";
import m11 from "./_11";
import m12 from "./_12";

export default [
	...m10,
	...m11,
	...m12
];
